import { panelsForKind } from "~/constants/app-options"
import useAppContext from "~/hooks/useAppContext"
import Icons from "~/components/Icons"
import { useTranslation } from "react-i18next"
import useSetIsSidebarOpen from "~/hooks/useSetIsSidebarOpen"
import useDesignEditorContext from "~/hooks/useDesignEditorContext"

function PanelsList() {
  const { activePanel } = useAppContext()
  const { contentKind } = useDesignEditorContext()
  const { t } = useTranslation("editor")
  const PANEL_ITEMS = panelsForKind(contentKind)

  return (
    <nav className="ar-editor-rail" aria-label="Editor panels">
      {PANEL_ITEMS.map((panelListItem) => (
        <PanelListItem
          label={t(`panels.panelsList.${panelListItem.id}`)}
          name={panelListItem.name}
          key={panelListItem.name}
          icon={panelListItem.name}
          activePanel={activePanel}
        />
      ))}
    </nav>
  )
}

function PanelListItem({ label, icon, activePanel, name }: any) {
  const { setActivePanel } = useAppContext()
  const setIsSidebarOpen = useSetIsSidebarOpen()
  // @ts-ignore
  const Icon = Icons[icon]
  const active = String(name).toLowerCase() === String(activePanel).toLowerCase()

  return (
    <button
      id={"EditorPanelList"}
      type="button"
      className={`ar-rail-item ${active ? "active" : ""}`}
      title={label}
      onClick={() => {
        setIsSidebarOpen(true)
        setActivePanel(name)
      }}
    >
      <Icon size={22} />
      <span>{label}</span>
    </button>
  )
}

export default PanelsList
